import {
  CREATIVE_TEMPLATE_SORT_NAME_ASC,
  CREATIVE_TEMPLATE_SORT_NAME_DESC,
  CREATIVE_TEMPLATE_SORT_NEWEST_FIRST,
  CREATIVE_TEMPLATE_SORT_OLDEST_FIRST,
} from "../../../utils/constants";

const getTemplateUpdatedTime = ({ card }) =>
  card.updateTime || card.updatedAt || 0;

const getTemplateSortName = ({ card }) =>
  String(card.name || "")
    .trim()
    .toLowerCase();

export const sortCreativeTemplateCards = ({ cards = [], sortOrder }) => {
  const sortedCards = [...cards];

  switch (sortOrder) {
    case CREATIVE_TEMPLATE_SORT_OLDEST_FIRST:
      return sortedCards.sort(
        (cardA, cardB) =>
          getTemplateUpdatedTime({ card: cardA }) -
          getTemplateUpdatedTime({ card: cardB })
      );
    case CREATIVE_TEMPLATE_SORT_NAME_ASC:
      return sortedCards.sort((cardA, cardB) =>
        getTemplateSortName({ card: cardA }).localeCompare(
          getTemplateSortName({ card: cardB })
        )
      );
    case CREATIVE_TEMPLATE_SORT_NAME_DESC:
      return sortedCards.sort((cardA, cardB) =>
        getTemplateSortName({ card: cardB }).localeCompare(
          getTemplateSortName({ card: cardA })
        )
      );
    case CREATIVE_TEMPLATE_SORT_NEWEST_FIRST:
    default:
      return sortedCards.sort(
        (cardA, cardB) =>
          getTemplateUpdatedTime({ card: cardB }) -
          getTemplateUpdatedTime({ card: cardA })
      );
  }
};
